import { DialogObject } from '../../../../components/dialog/dialog.types';
import { PpmRepository } from '../../../../store/ppm-state/ppm-state.repository';

interface getPpmDeleteObjectProps {
  store: PpmRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPpmDeleteObject = ({ store, representation, action, toggleVisiblity }: getPpmDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression d'un ppm ${representation}`,
    description: 'Ce ppm sera supprimé avec succès',
    onHide() {
      store.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => toggleVisiblity?.(),
        variant: 'secondary',
      },
    ],
  };
};
